import { emit } from '@atlassian/forge-ui/events';
import type { ChangeEvent } from '@atlassian/jira-issue-ecosystem/src/types.tsx';

export const EVENT_NAME = 'JIRA_ISSUE_CHANGED';

export const emitIssueChangedEvent = (eventDetails: ChangeEvent) => {
	emit(EVENT_NAME, eventDetails);
};
